<p-tabView>
  <p-tabPanel header="Usuários do Sistema">
    <app-table
      [lazy]="false"
      [elements]="allowedUsers"
      [addButtonAction]="true"
      (addButtonClick)="addNewUser()"
      addLabel="Novo usuário"
      [cols]="cols"
      [exportExcel]="false"
      [exportPdf]="false"
      *ngIf="allowedUsers && actionButtons"
      modelName="usuários"
      sortField="username"
      [sortOrder]="-1"
      [actionButtons]="actionButtons"
      (actionButtonClick)="callAction($event)"
      [dropdownFilters]="dropdownFilters"
      [changeColumns]="true"
      [multiSelectFilter]="true"
      tableTitle="Usuários do sistema"
    ></app-table>
  </p-tabPanel>
  <p-tabPanel header="Usuários Externos (GCP)">
    <app-table
      [lazy]="false"
      [elements]="externalDbUsers"
      [addButton]="false"
      [cols]="externalCols"
      [exportExcel]="false"
      [exportPdf]="false"
      *ngIf="externalDbUsers && externalActionButtons"
      modelName="usuários externos"
      sortField="dbUsername"
      [sortOrder]="1"
      [changeColumns]="false"
      [actionButtons]="externalActionButtons"
      (actionButtonClick)="callExternalAction($event)"
      tableTitle="Usuários externos do banco de dados"
    ></app-table>
  </p-tabPanel>
</p-tabView>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
